import React, { HTMLAttributes } from 'react';
import { ActionMenuContainer } from './ActionMenu.styles';
import Grid from '@material-ui/core/Grid';

type Props = HTMLAttributes<HTMLElement> &
  Partial<{
    leftSide: JSX.Element | null | undefined;
    rightSide: JSX.Element | null | undefined;
  }>;

const ActionMenu = ({
  className,
  leftSide: Left = null,
  rightSide: Right = null,
  children,
  ...rest
}: Props) => {
  return (
    <ActionMenuContainer
      className={className}
      container={true}
      wrap="wrap"
      {...rest}
    >
      <Grid item xs={12} md={4}>
        {Left}
      </Grid>
      <Grid item xs={12} md={4}>
        {Right}
      </Grid>
      {children}
    </ActionMenuContainer>
  );
};

export default ActionMenu;
